import { graphql } from 'app/generated/gql'

/**
 * The detail behind a Call activity, for the Last Communication hover.
 *
 * Deliberately narrow: `gqlFetchOne('call', id)` would send MODEL_FIELDS.call,
 * which drags every transcript person, recording and UTM field across the wire
 * for a tooltip that shows four lines.
 */
export const LAST_COMM_CALL_QUERY = graphql(`
  query LastCommCall($id: ID!) {
    call(id: $id) {
      id
      direction
      duration
      answered
      answerer
      note
      allPatientOutcomes
      ai {
        summary
        answerer
      }
    }
  }
`)

export const CONTACT_STATUS_CHANGES_QUERY = graphql(`
  query ContactStatusChanges($search: String, $pagination: PaginationInput, $sort: SortInput) {
    activities(search: $search, pagination: $pagination, sort: $sort) {
      total
      hits {
        id
        activityDate
        createdDate
        source
        data
        description
      }
    }
  }
`)
